import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  cardMobile: {
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      '& > *:first-child': {
        marginBottom: 8,
      },
    },
  },
  newFont: {
    fontSize: '1em',
    lineHeight: '1.5em',
  },
  radio: {
    margin: 0,
    display: 'flex',
    '&:not(:last-child)': {
      marginBottom: theme.spacing(2),
    },
    '& .MuiFormControlLabel-label': {
      height: 'auto',
    },
    '& .MuiButtonBase-root.MuiIconButton-root': {
      padding: 0,
      marginRight: theme.spacing(1),
    },
    '& .MuiButtonBase-root.MuiIconButton-root.Mui-focusVisible': {
      border: 'none',
      boxShadow: '0 0 0 4px rgb(0 125 205 / 30%) !important',
    },
    '&:hover .MuiRadio-root.MuiIconButton-root:not(.Mui-checked) span svg path':
      {
        stroke: '#212121',
      },
  },
}));
